// extracted by mini-css-extract-plugin
export default {"container":"kX0OUm","lg":"uFdopZ"};